import {
  ON_PRESS_TAG_DROPDOWN,
  ON_PRESS_MORE_DROPDOWN,
  ON_PRESS_COMPOSE,
  ON_PRESS_ADD_EVENT,
  ON_PRESS_ADD_CONTACT,
  OPEN_EVENT_DETAIL_MODAL,
  CLOSE_EVENT_DETAIL_MODAL,
  SET_EVENTS_COUNTS,
  OPEN_ADD_TASK_MODAL,
  CLOSE_ADD_TASK_MODAL,
  OPEN_TASK_DETAIL_MODEL,
  CLOSE_TASK_DETAIL_MODEL,
  OPEN_ADD_COLLECTION_MODEL,
  CLOSE_ADD_COLLECTION_MODEL,
  OPEN_CUSTOMER_DETAILS_MODEL,
  CLOSE_CUSTOMER_DETAILS_MODEL,
  OPEN_VEHICLE_DETAILS_MODEL,
  CLOSE_VEHICLE_DETAILS_MODEL,
} from "../actions";

const initialState = {
  isTagDropDown: false,
  isMoreDropDown: false,
  isInbox: true,
  isEventModal: false,
  isContactModal: false,
  isModalOpen: false,
  isTaskDetailModalOpen: false,
  isAddCollectionModalOpen:false,
  isCustomerDetailModalOpen: false,
  isVehicleDetailModalOpen:false,
  selectedEvent: null,
  taskModalData: {},
  addTaskModalData: {},
  addCollectionReceiveID:null,
  userCommentModelData: {},
  eventsCountsData: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ON_PRESS_TAG_DROPDOWN: {
      return {
        ...state,
        isTagDropDown: !state.isTagDropDown,
        isMoreDropDown: false,
      };
    }

    case ON_PRESS_MORE_DROPDOWN: {
      return {
        ...state,
        isMoreDropDown: !state.isMoreDropDown,
        isTagDropDown: false,
      };
    }

    case ON_PRESS_COMPOSE: {
      return {
        ...state,
        isInbox: action.payload,
      };
    }

    case ON_PRESS_ADD_EVENT: {
      return {
        ...state,
        isEventModal: !state.isEventModal,
      };
    }
    case OPEN_EVENT_DETAIL_MODAL:
      return {
        ...state,
        isModalOpen: true,
        selectedEvent: action.payload
      };
    case SET_EVENTS_COUNTS:
    return {
      ...state,
      eventsCountsData: action.payload
    };
    case OPEN_TASK_DETAIL_MODEL:
    return {
      ...state,
      isTaskDetailModalOpen:true,
      taskModalData: action.payload
    };
    case CLOSE_TASK_DETAIL_MODEL:
    return {
      ...state,
      isTaskDetailModalOpen:false,
    };
    case OPEN_ADD_COLLECTION_MODEL:
    return {
      ...state,
      isAddCollectionModalOpen:true,
      addCollectionReceiveID: action.payload
    };
    case CLOSE_ADD_COLLECTION_MODEL:
    return {
      ...state,
      isAddCollectionModalOpen:false,
    };
    case CLOSE_EVENT_DETAIL_MODAL:
      return {
        ...state,
        isModalOpen: false,
        selectedEvent: null
      };

    case ON_PRESS_ADD_CONTACT: {
      return {
        ...state,
        isContactModal: !state.isContactModal,
      };
    }
    case OPEN_ADD_TASK_MODAL:
      return {
        ...state,
        isAddTaskModalOpen: true,
        addTaskModalData:action.payload
      };
      case CLOSE_ADD_TASK_MODAL:
      return {
        ...state,
        isAddTaskModalOpen: false,
        addTaskModalData:null
      };
      case OPEN_CUSTOMER_DETAILS_MODEL:
      return {
        ...state,
        isCustomerDetailModalOpen: true,
      };
      case CLOSE_CUSTOMER_DETAILS_MODEL:
      return {
        ...state,
        isCustomerDetailModalOpen:false
      };
    case OPEN_VEHICLE_DETAILS_MODEL:
      return {
        ...state,
        isVehicleDetailModalOpen: true,
      };
    case CLOSE_VEHICLE_DETAILS_MODEL:
      return {
        ...state,
        isVehicleDetailModalOpen:false
      };

    default:
      return state;
  }
};
